
const base_url =   {
    "base_url":"https://api.mteltech.com/admin"
 //"base_url":"http://localhost:8000/admin"   // https://api.mteltech.com/admin
}
 
export default  base_url 
